module.exports = __webpack_public_path__ + "img/hipercard.f94b27cb.svg";